<template>
  <div class="main">
    <mInfoList fenlei="信息公告"></mInfoList>
  </div>
</template>
<script>
import mInfoList from "@/components/mInfoList.vue";
export default {
  data() {
    return {
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    
  },
  components: {
    mInfoList
  }
};
</script>
<style lang="less" scoped>
.main {
  margin-top: 20px;
  width: 100%;
  .wrapper {
    width: 95%;
    margin: 30px auto;
    .content {
      width: 100%;
      line-height: 1.5;
      color: #000;
    }
  }
}
</style>